import React, { PropsWithChildren } from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Box, type Types } from '@fiverr-private/theme';
import * as classes from './Table.ve.css';

interface TableProps extends PropsWithChildren<unknown> {}

export const Table = ({ children }: TableProps) => (
    <Container
        overflow="auto"
        position="relative"
        width="100%"
        borderWidth="sm"
        borderStyle="solid"
        borderColor="grey_400"
    >
        <Box as="table" width="100%">
            {children}
        </Box>
    </Container>
);

interface TableHeaderProps extends PropsWithChildren<unknown> {}

export const TableHeader = ({ children }: TableHeaderProps) => (
    <Box as="thead" className={classes.header}>
        {children}
    </Box>
);

interface TableBodyProps extends PropsWithChildren<unknown> {}

export const TableBody = ({ children }: TableBodyProps) => (
    <Box as="tbody" className={classes.body}>
        {children}
    </Box>
);

interface TableRowProps extends PropsWithChildren<unknown> {
    isSticky?: boolean;
}

export const TableRow = ({ children, isSticky = false }: TableRowProps) => (
    <Box
        as="tr"
        className={classes.row}
        borderBottomWidth="sm"
        borderStyle="solid"
        borderColor="grey_400"
        {...(isSticky && {
            position: 'sticky',
            top: '0px',
            zIndex: '1',
        })}
    >
        {children}
    </Box>
);

interface TableHeadProps extends PropsWithChildren<unknown> {
    width?: Types.BoxType['width'];
    zIndex?: Types.BoxType['zIndex'];
    isSticky?: boolean;
}

export const TableHead = ({ children, width, zIndex, isSticky = false }: TableHeadProps) => {
    const classNames = [classes.head];

    if (isSticky) {
        classNames.push(classes.stickyCell);
    }

    return (
        <Box
            as="th"
            minWidth={width}
            width={width}
            zIndex={zIndex}
            borderRightWidth="sm"
            borderStyle="solid"
            borderColor="grey_400"
            textAlign="start"
            backgroundColor="white"
            className={classNames.join(' ')}
        >
            {children}
        </Box>
    );
};

interface TableCellProps extends PropsWithChildren<unknown> {
    backgroundColor?: Types.BoxType['backgroundColor'];
    isSticky?: boolean;
}

export const TableCell = ({ children, backgroundColor = 'white', isSticky = false }: TableCellProps) => {
    const classNames = [classes.cell];

    if (isSticky) {
        classNames.push(classes.stickyCell);
    }

    return (
        <Box
            as="td"
            borderRightWidth="sm"
            borderStyle="solid"
            borderColor="grey_400"
            backgroundColor={backgroundColor}
            className={classNames.join(' ')}
            style={{ verticalAlign: 'middle' }}
        >
            {children}
        </Box>
    );
};
